//
import { Component } from "react"

import { genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups.js"

import { UserTeamFilter, UserOrganizationFilter } from "shared/search/containers/Filter/UserFilters"

// eslint-disable-next-line @typescript-eslint/ban-types
export class UserTeamFilterGroup extends Component {
    static defaultProps = {
        filters: [UserTeamFilter],
        uniqueFilterGroupId: "userTeamFilterGroup",
        displayLabel: "Team",
        helpText: "Filter the users at your organization based on which teams they are on.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class UserOrganizationFilterGroup extends Component {
    static defaultProps = {
        filters: [UserOrganizationFilter],
        uniqueFilterGroupId: "userOrgFilterGroup",
        displayLabel: "Organization",
        helpText:
            "Filter the users you work with based on which organizations" +
            "they are part of (primarily relevant for managing consultants).",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
